export default {"src":"/_next/static/media/cycle.ad7ab541.svg","height":21,"width":75,"blurWidth":0,"blurHeight":0};